// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.

// tslint:disable-next-line: class-name
export class URL_PARAMS {
    static readonly OVERVIEW_PARAM_NAME            = 'overview';
    static readonly OVERVIEW_CONNECTED             = 'connected';
    static readonly OVERVIEW_OFFLINE               = 'offline';
    static readonly OVERVIEW_ELIGIBLE              = 'eligible';
    static readonly OVERVIEW_LOCKED                = 'locked';
    static readonly OVERVIEW_UNCONFIGURED_SECURE   = 'unconfiguredSecureDrive';
    static readonly OVERVIEW_NO_PROTECTION         = 'noProtection';


    static readonly PROTECTION_PARAM_NAME          = 'protection';
    static readonly PROTECTION_FOLDER              = 'folder';
    static readonly PROTECTION_CUSTOM_FILE         = 'customFile';
    static readonly PROTECTION_OFFICE              = 'office';
    static readonly PROTECTION_ADOBE               = 'adobe';
    static readonly PROTECTION_SECURE_DRIVE        = 'secureDrive';
}
